import React from 'react';

function SearchForm({ params, handleChange, projectInput, handleSearch, handleClear, clientList, userList, projectcategory }) {
  return (
    <form className="search_pj_form" onSubmit={handleSearch}>
      <div className="pj-list">
        <div style={{ display: "inline-block" }}>
          <div style={{ margin: "10px" }}>
            <label>ClientName</label>
            &nbsp;
            <select
              name="t_client_id"
              value={params.t_client_id}
              onChange={handleChange}
            >
              <option value="">-----</option>
              {clientList.map((client) => (
                <option key={client.id} value={client.id}>
                  {client.name}
                </option>
              ))}
            </select>

            <label style={{ paddingLeft: "40px" }}>Staff</label>
            &nbsp;
            <select
              name="manager_id"
              style={{ width: "30%" }}
              value={params.manager_id}
              onChange={handleChange}
            >
              <option value="">-----</option>
              {userList.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.name}
                </option>
              ))}
            </select>
          </div>

          <div style={{ margin: "10px" }}>
            <label>Project Name</label>
            &nbsp;
            <input
              type="text"
              name="name_abbreviation"
              value={params.name_abbreviation}
              onChange={handleChange}
            />
            <label style={{ paddingLeft: "20px", display: "inline-block" }}>Category</label>
            &nbsp;
            <select
              name="category_cd"
              value={params.category_cd}
              onChange={handleChange}
            >
              <option value="">-----</option>
              {projectcategory && projectcategory.map((category) => (
                <option key={category.id} value={category.cd}>
                  {category.code_value1}
                </option>
              ))}
            </select>
          </div>

          <div style={{ padding: "10px" }}>
            <button type="button" className="btn btn-success" onClick={handleSearch}>
              Search
            </button>
            &nbsp;
            <button type="button" className="btn btn-success" onClick={handleClear}>
              Clear
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-default"
              onClick={projectInput}
            >
              <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

export default SearchForm;

